import { compose, mapProps, acceptProps, withHooks } from 'vue-compose';

import dataView from '~lib/common/hoc/dataView';

import CaseGrading from './CaseGrading.vue';
import medicationQueries from '~lib/common/queries/Medication';
import treatmentQueries from '~lib/common/queries/Treatment';
import oxygenQueries from '~lib/common/queries/Oxygen';

const enhance = compose(
  dataView({ queries: treatmentQueries }),
  mapProps(props => ({
    ...props,
    ivs: props.data.filter(t => t.category === 'IV'),
    ivFluids: props.data.filter(t => t.category === 'IV_FLUID'),
    treatments: props.data,
  })),
  acceptProps(['data']),
  dataView({ queries: medicationQueries, dontFetchOnLoad: true }),
  mapProps(props => ({
    ...props,
    medications: props.data,
  })),
  acceptProps(['data']),
  withHooks({
    mounted() {
      this.$emit('setQueryContext', {
        type: 'case',
        id: this.caseConf.id,
      });
      this.$emit('fetch');
    }
  }),
  dataView({ queries: oxygenQueries, dontFetchOnLoad: true }),
  mapProps(props => ({
    ...props,
    oxygens: props.data,
  })),
  acceptProps(['data']),
  withHooks({
    mounted() {
      this.$emit('setQueryContext', {
        type: 'case',
        id: this.caseConf.id,
      });
      this.$emit('fetch');
    }
  }),
);

export default enhance(CaseGrading);
